<style lang="less">	
    .main-header{
        position: fixed;
        top: 0;
        left: 0px;
        width: 100%;
        // background: #1e88e5 !important;
		background: linear-gradient(90deg,#1d42ab,#2173dc,#1e93ff) !important;
        border-bottom: none !important;
        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, .2), 0 3px 12px 0 rgba(0, 0, 0, .2);
        z-index: 20;
        color: #fff;
        display: inline;

        .header-container {
            height: 100%;
            font-size: 14px;
			width: 100%;
			height: 56px;
			line-height: 56px;			

            .navbar-header {
                float: left;
                margin: 0em 2em 0em 1em;
                white-space: nowrap;
                letter-spacing: 3px;
                font-size: 2.1em;
                text-shadow: #333 0 2px 3px;
            }

            .navbar-collapse {
                margin-right: -15px;
                position: absolute;
                top: 0;
                right: 15px;
                z-index: 2;
                height: 56px;
                display: block !important;
                margin-left: 5px;
                padding-right: 0;
                border-top: none !important;
                box-shadow: none;
                color: #ccc;

                .nav {
                    margin: 0;

                    >li {
                        float: left;
                        a {
                            padding: 0px 10px 0px 10px;
                            color: #fff !important;
                        }
                    }
                    >li.navbar-menu {
                        font-size: 16px;
                    }
                    >li:hover {
                        // background-color: #1e88e5 !important;
                        // padding-top: 3px;
                        // -webkit-transition: bottom 200ms ease;
                        // -moz-transition: bottom 200ms ease;
                        // -o-transition: bottom 200ms ease;
                        // -ms-transition: bottom 200ms ease;
                        // transition: bottom 200ms ease;
                        // box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 12px 0 rgba(0, 0, 0, 0.2);
						border-bottom: #333 solid;
                    }
                    >li.active {
                        // background-color: #1e88e5 !important;
                        // padding-top: 3px;
                        // -webkit-transition: bottom 200ms ease;
                        // -moz-transition: bottom 200ms ease;
                        // -o-transition: bottom 200ms ease;
                        // -ms-transition: bottom 200ms ease;
                        // transition: bottom 200ms ease;
                        // box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 12px 0 rgba(0, 0, 0, 0.2);
						border-bottom: #333 solid;
                    }
                    >li.navbar-empty-li {
                        padding-right: 15px;
                        height: 56px;
                    }
                    >li.navbar-empty:hover {
                        background-color: #1e88e5 !important;
                        box-shadow: none !important;
                        padding-top: 0px !important;
                    }
                }

                .dropdown-menu-item:hover {
                    background: #fff;
                    color: #333 !important;
                    .dropdown-menu {
                        display: block;
                    }
                }
            }
        }
    }
</style>
<template>
    <div>
    <header class="main-header">
        <div class="header-container">
            <div class="navbar-header">
                <span class="logo-name">{{projectName}}</span>
            </div>
            <nav class="collapse navbar-collapse">
                <ul class="nav navbar-nav navbar-right">
                    <li v-for="(menu, index) in menus" :class="{'active': index == activeIndex}" class="navbar-menu" v-if="1 == menu.tree.wType" @click="menuItemClick(menu, index)">
                        <a>{{menu.label}}</a>
                    </li>
                    <li class="navbar-empty navbar-empty-li">
                        <a></a>
                    </li>
                    <li class="navbar-empty">
                        <a class="dropdown-menu-item">
                            {{userName}}<i class="caret" aria-hidden="true"></i>
                            <ul class="dropdown-menu wsui-anim-upbit wsui-anim">
                                <li @click="profileFunDialog"><span><i class="fa fa-sign-out" aria-hidden="true"></i>账户设置</span></li>
                            </ul>
                        </a>
                    </li>
                    <li class="navbar-empty">
                        <a>
                            <el-tooltip class="item tip-logout" effect="dark" content="退出" placement="bottom" style="padding:0px;">
                                <i class="fa fa-sign-out pointer-item" aria-hidden="true" @click="logout"></i>
                            </el-tooltip>
                        </a>
                    </li>
                </ul>
            </nav>      
        </div>
		<wtags/>
    </header>
    <!--个人设置-->
    <ws-modal title="个人设置" width="720px" v-model="profileVisiable" close-footer :showClose="true">
    <!--<el-dialog title="个人设置" :visible.sync="profileVisiable" :close-on-press-escape="false" :close-on-click-modal="false">-->
        <ws-profile></ws-profile>
    <!--</el-dialog>-->
    </ws-modal>    	
    </div>   
</template>
<script>
    import wsProfile from './profile'
	import wtags from './tags.vue';
    export default {
        components: {
            wsProfile,
			wtags
        },
        data() {
        	return {
                profileVisiable: false //配置是否显示
        	}
        },
        computed: {
        	leftSideOpen() { //左边关闭状态计算属性
        		const isOpen =  this.$store.getters.framework_leftSideOpenStatus;
        		return isOpen;
        	},
            projectName() { //系统名
                const projectName_ =  this.$store.getters.auth_projectName;
                return projectName_;
            },
            userName() { //登录的用户名
                const user_ =  this.$store.getters.auth_user;
                let userName_ = "";
                if(user_) {
                    userName_ = user_.realUsername;
                }
                return userName_;
            },
            menus() { //菜单信息
                let menuTree_ =  this.$store.getters.auth_menuTree;
                if(menuTree_) {
                    return menuTree_.children;
                }
                return [];
            },
            //激活的索引
            activeIndex() {
                let activeIndex_ =  this.$store.getters.currentActiveTopPath;
                return activeIndex_;
            }
        },
		mounted() {
			
		},
        methods: {
            //退出登录
            logout:function(){
                var _this=this;
                this.$confirm('确认退出吗?', '提示', {
                    //type: 'warning'
                }).then(() => {
                    //发送请求到后台登出会话
                    this.$store.dispatch('authLogout');
                    window.location.href = 'login.html';
                }).catch(() => {
                            
                });
            },
            profileFunDialog() { //账户设置弹框
                this.profileVisiable = true;
            },
            menuItemClick(item_, index_) { //菜单点击事件
                if(this.activeIndex == index_) {
                    return;
                }
                let router_ = this.$router;
                this.$store.dispatch('frameworkTopMenuActiveIndex', {index: index_, item: item_, 'router': router_});
            }
        }
    }
</script>


// WEBPACK FOOTER //
// header.vue?4f8e5f5c